import { AutogenModelBrokerageWorkflowNextStatus, AutogenRowBrokerageWorkflowNextStatus } from "./autogen/AutogenModelBrokerageWorkflowNextStatus";

export class ModelBrokerageWorkflowNextStatus extends AutogenModelBrokerageWorkflowNextStatus<RowBrokerageWorkflowNextStatus> {
	constructor() {
		super(RowBrokerageWorkflowNextStatus);
	}
}

export class RowBrokerageWorkflowNextStatus extends AutogenRowBrokerageWorkflowNextStatus {
}